export const isNonExpandActionClick = (e, allowLinks) => {
  return !(
    !e.target.closest("div[role='presentation']") &&
    !e.target.closest("div[contenteditable='true']") &&
    !e.target.closest(".noExpand") &&
    (e.target.closest(".expand") || !e.target.closest("button, input, a") || (allowLinks && !e.target.closest("button, input")))
  )
};
